export default class Credito implements ICredito {
  public saldo!: number;

  constructor(param: ICredito) {
    Object.assign(this, param);
  }
}

interface ICredito {
  saldo: number;
}
